import { jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import escapeRegExp from "lodash/escapeRegExp";
import { Box } from "../../../../../Box/index.js";
import { Badge } from "../../../../common/index.js";
import { Typography } from "../../../../../Typography/index.js";
import SelectInput_styles from "../../../SelectInput.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function Option_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else Option_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const Option = (t0)=>{
    var _option_badge;
    const $ = c(69);
    const { inputValue, renderOption, optionProps, option } = t0;
    const { classes } = SelectInput_styles();
    if (renderOption) {
        const t1 = option.value;
        let t2;
        if ($[0] !== option || $[1] !== renderOption) {
            t2 = renderOption(option);
            $[0] = option;
            $[1] = renderOption;
            $[2] = t2;
        } else t2 = $[2];
        let t3;
        if ($[3] !== option.value || $[4] !== optionProps || $[5] !== t2) {
            t3 = /*#__PURE__*/ createElement("li", _object_spread_props(_object_spread({}, optionProps), {
                key: t1
            }), t2);
            $[3] = option.value;
            $[4] = optionProps;
            $[5] = t2;
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    const isBottom = (null == (_option_badge = option.badge) ? void 0 : _option_badge.position) === "bottom";
    const t1 = option.label;
    let T0;
    let T1;
    let T2;
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[7] !== classes.defaultOption || $[8] !== classes.menuItem || $[9] !== classes.option || $[10] !== inputValue || $[11] !== isBottom || $[12] !== option.badge || $[13] !== option.disabled || $[14] !== option.label || $[15] !== option.value || $[16] !== optionProps) {
        let t16;
        if ($[34] !== inputValue) {
            t16 = escapeRegExp(inputValue);
            $[34] = inputValue;
            $[35] = t16;
        } else t16 = $[35];
        const words = t1.split(new RegExp(`(${t16})`, "gi"));
        t13 = optionProps;
        t14 = option.value;
        const t17 = !option.badge;
        if ($[36] !== classes.defaultOption || $[37] !== classes.menuItem || $[38] !== classes.option || $[39] !== t17) {
            t15 = classnames(classes.option, classes.menuItem, {
                [classes.defaultOption]: t17
            });
            $[36] = classes.defaultOption;
            $[37] = classes.menuItem;
            $[38] = classes.option;
            $[39] = t17;
            $[40] = t15;
        } else t15 = $[40];
        T2 = Box;
        t7 = "flex";
        t8 = isBottom ? "start" : "center";
        t9 = isBottom ? "column" : "row";
        t10 = "8";
        t11 = option.disabled ? "none" : "auto";
        if ($[41] !== isBottom || $[42] !== option.badge) {
            t12 = option.badge && /*#__PURE__*/ jsx(Box, {
                order: isBottom ? 1 : 0,
                children: /*#__PURE__*/ jsx(Badge, {
                    title: option.badge.title,
                    description: option.badge.description,
                    color: option.badge.color
                })
            });
            $[41] = isBottom;
            $[42] = option.badge;
            $[43] = t12;
        } else t12 = $[43];
        T1 = Box;
        t6 = isBottom ? 0 : 1;
        T0 = Typography;
        t2 = "span";
        t3 = "body3";
        t4 = inputValue ? "text.light.tertirary" : "text.light.primary";
        t5 = inputValue && words.map((part, i)=>/*#__PURE__*/ jsx(Typography, {
                component: "span",
                variant: "body3",
                color: part.toLowerCase() === inputValue.toLowerCase() ? "text.light.primary" : "text.light.tertirary",
                children: part
            }, i));
        $[7] = classes.defaultOption;
        $[8] = classes.menuItem;
        $[9] = classes.option;
        $[10] = inputValue;
        $[11] = isBottom;
        $[12] = option.badge;
        $[13] = option.disabled;
        $[14] = option.label;
        $[15] = option.value;
        $[16] = optionProps;
        $[17] = T0;
        $[18] = T1;
        $[19] = T2;
        $[20] = t10;
        $[21] = t11;
        $[22] = t12;
        $[23] = t13;
        $[24] = t14;
        $[25] = t15;
        $[26] = t2;
        $[27] = t3;
        $[28] = t4;
        $[29] = t5;
        $[30] = t6;
        $[31] = t7;
        $[32] = t8;
        $[33] = t9;
    } else {
        T0 = $[17];
        T1 = $[18];
        T2 = $[19];
        t10 = $[20];
        t11 = $[21];
        t12 = $[22];
        t13 = $[23];
        t14 = $[24];
        t15 = $[25];
        t2 = $[26];
        t3 = $[27];
        t4 = $[28];
        t5 = $[29];
        t6 = $[30];
        t7 = $[31];
        t8 = $[32];
        t9 = $[33];
    }
    const t16 = !inputValue && option.label;
    let t17;
    if ($[44] !== T0 || $[45] !== t16 || $[46] !== t2 || $[47] !== t3 || $[48] !== t4 || $[49] !== t5) {
        t17 = /*#__PURE__*/ jsxs(T0, {
            component: t2,
            variant: t3,
            color: t4,
            children: [
                t5,
                t16
            ]
        });
        $[44] = T0;
        $[45] = t16;
        $[46] = t2;
        $[47] = t3;
        $[48] = t4;
        $[49] = t5;
        $[50] = t17;
    } else t17 = $[50];
    let t18;
    if ($[51] !== T1 || $[52] !== t17 || $[53] !== t6) {
        t18 = /*#__PURE__*/ jsx(T1, {
            order: t6,
            children: t17
        });
        $[51] = T1;
        $[52] = t17;
        $[53] = t6;
        $[54] = t18;
    } else t18 = $[54];
    let t19;
    if ($[55] !== T2 || $[56] !== t10 || $[57] !== t11 || $[58] !== t12 || $[59] !== t18 || $[60] !== t7 || $[61] !== t8 || $[62] !== t9) {
        t19 = /*#__PURE__*/ jsxs(T2, {
            display: t7,
            alignItems: t8,
            flexDirection: t9,
            gap: t10,
            pointerEvents: t11,
            children: [
                t12,
                t18
            ]
        });
        $[55] = T2;
        $[56] = t10;
        $[57] = t11;
        $[58] = t12;
        $[59] = t18;
        $[60] = t7;
        $[61] = t8;
        $[62] = t9;
        $[63] = t19;
    } else t19 = $[63];
    let t20;
    if ($[64] !== t13 || $[65] !== t14 || $[66] !== t15 || $[67] !== t19) {
        t20 = /*#__PURE__*/ createElement("li", _object_spread_props(_object_spread({}, t13), {
            key: t14,
            className: t15
        }), t19);
        $[64] = t13;
        $[65] = t14;
        $[66] = t15;
        $[67] = t19;
        $[68] = t20;
    } else t20 = $[68];
    return t20;
};
export { Option };
